// @ts-nocheck
/**
 * drawSaveHistory.ts
 * ドロー保存・エクスポート・履歴管理メソッド
 * App.vue から切り出し
 */

import {
  downloadTextFile,
  downloadSimaText,
  downloadGeoJSONAsCSV,
  DXFDownload,
  gpxDownload,
  geojsonDownload,
  kmlDownload,
  getNowFileNameTimestamp,
} from '@/js/downLoad'
import { geoJSONToSIMA } from '@/js/simaExport'
import { drawCancel, drawConfirm, drawUndo, drawRedo } from '@/js/draw'
import { clickCircleSource } from '@/js/layers'
import { zahyokei } from '@/js/downLoad'
import { exportVisibleDXF_fromMap01 } from '@/js/utils/context-menu'
import { getUsageTracker } from '@/js/utils/usageTracker'
import store from '@/store'

type VM = any

export function dialogForDlOpen(vm: VM) {
  vm.dialogForDl = true
}

export function dialogForSaveDXFOpen(vm: VM) {
  vm.dialogForSaveDXF2 = true
}

export function saveGpx(vm: VM) {
  gpxDownload(JSON.parse(vm.$store.state.clickCircleGeojsonText))
  vm.dialogForDl = false
}

export async function saveSima(vm: VM) {
  const geojson = JSON.parse(vm.$store.state.clickCircleGeojsonText)
  // geoJSONToSIMA内で座標変換を行うため、事前変換は不要
  const simaText = geoJSONToSIMA(geojson)

  // XMLインポート経由の地物があるかチェック
  const hasXmlFeature = geojson.features?.some(f => f.properties?._isHomukyokuXml)
  const baseName = getNowFileNameTimestamp()
  const fileName = hasXmlFeature ? `${baseName}_XML` : baseName

  downloadTextFile(`${fileName}.sim`, simaText, 'shift-jis')

  // ログイン中ならマイルームに保存
  const userId = vm.$store.state.userId
  if (userId) {
    try {
      const formData = new FormData()
      formData.append('uid', userId)
      formData.append('name', fileName)
      formData.append('simatext', simaText)
      formData.append('zahyokei', store.state.zahyokei)

      const response = await axios.post('/oh3/php/userSimaInsert.php', formData)
      if (response.data && (response.data.lastId || response.data.id)) {
      }
    } catch (e) {
      console.error('[saveSima] マイルーム保存エラー:', e)
    }
  }

  vm.dialogForDl = false
}

export function saveGeojson(vm: VM) {
  const geojson = JSON.parse(vm.$store.state.clickCircleGeojsonText)
  geojsonDownload(geojson)
  vm.dialogForDl = false
}

export function saveKml(vm: VM) {
  kmlDownload(JSON.parse(vm.$store.state.clickCircleGeojsonText))
  vm.dialogForDl = false
}

export function saveDxf(vm: VM) {
  DXFDownload()
  vm.dialogForSaveDXF2 = false
}

export function execVisibleDxfExport(vm: VM) {
  if (!vm.s_zahyokei) {
    alert('座標系を選択してください。')
    return
  }
  const zahyokeiItem = zahyokei.find(item => item.kei === vm.s_zahyokei)
  if (!zahyokeiItem) {
    alert('座標系が見つかりません。')
    return
  }
  getUsageTracker()?.trackEvent('contextmenu', 'click', `dxf-export-${vm.s_zahyokei}-${vm.visibleDxfCadType}`)
  exportVisibleDXF_fromMap01({
    includeExcluded: false,
    zahyokei: zahyokeiItem.code,
    cadType: vm.visibleDxfCadType
  })
  vm.dialogForVisibleDXF = false
}

export function saveHistory(vm: VM) {
  // ディープコピーで保存！
  const map = vm.$store.state.map01
  let mainSourceGeojson
  try {
    if (map && map.getSource('click-circle-source')) {
      const source = map.getSource('click-circle-source');
      mainSourceGeojson = vm.getSourceData(source);
    } else {
      // clickCircleGeojsonTextが有効なJSONかどうか確認
      const geojsonText = store.state.clickCircleGeojsonText
      if (geojsonText && typeof geojsonText === 'string' && geojsonText.trim()) {
        mainSourceGeojson = JSON.parse(geojsonText)
      }
    }
    if (mainSourceGeojson) {
      vm.history.push(JSON.parse(JSON.stringify(mainSourceGeojson)));
      // Undo後の新編集はredo履歴クリア
      vm.redoStack = [];
    }
  }catch (e) {
    // エラーは無視（初期化時に空データの場合がある）
  }
}

export async function undo() {
  drawUndo()
}

export async function redo() {
  drawRedo()
}

export function finishLine(vm: VM) {
  vm.isDrawingLine = false;
  vm.isDrawingFree = false;
  const map01 = vm.$store.state.map01
  // ガイドライン消去
  if (map01.getSource('guide-line-source')) {
    map01.getSource('guide-line-source').setData({
      type: 'FeatureCollection',
      features: []
    });
  }
  // フリーハンドプレビューレイヤー消去
  if (map01.getSource('freehand-preview-source')) {
    map01.getSource('freehand-preview-source').setData({
      type: 'FeatureCollection',
      features: []
    });
  }
  vm.tempLineCoords = []
  vm.tempLineCoordsGuide = []
  vm.tempFreehandCoords = []
  vm.tempPolygonCoords = []
  vm.tempLineCoordsCoords = []
}

